import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { MatStepperModule } from '@angular/material/stepper';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { ImageCropperModule } from 'ngx-image-cropper';
import { LoginPopupModalComponent } from './login-popup-modal/login-popup-modal.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PagesModule } from '../pages/pages.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { EditModalComponent } from './edit-modal/edit-modal.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { RescheduleModalComponent } from './reschedule-modal/reschedule-modal.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { ContactPopupModalComponent } from './contact-popup-modal/contact-popup-modal.component';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { CvResultModalComponent } from './cv-result-modal/cv-result-modal.component';
import { InterviewDialogComponent } from './interview-modal/interview-modal.component';
import {
  AppointmentSuccessDialogComponent,
} from './interview-modal/appointment-success-dialog/appointment-success-dialog.component';
import { WorkExperienceManagerComponent } from './work-experience-manager/work-experience-manager.component';
import { EducationManagerComponent } from './education-manager/education-manager.component';
import { ParsingLoadingModalComponent } from './parsing-loading-modal/parsing-loading-modal.component';
import { SuccessRegistrationModalComponent } from './success-registration-modal/success-registration-modal.component';
import { JobApplyModalComponent } from './job-apply-modal/job-apply-modal.component';
import { MatCheckbox } from '@angular/material/checkbox';
import {HttpLoaderFactory} from "../../main";
import {TranslateDocumentModalComponent} from "./translate-document-modal/translate-document-modal.component";
import {EmployerPartnerModalComponent} from "./employer-partner-modal/employer-partner-modal.component";

@NgModule( {
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [MatDatepickerModule,
        MatNativeDateModule,
        MatSlideToggleModule, SharedModule, MatStepperModule, FormsModule, MatOptionModule, MatSelectModule, ReactiveFormsModule, BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }), MatIconModule, ImageCropperModule, PagesModule, MatDatepickerModule, MatDividerModule, MatCardModule, MatAutocompleteModule, MatChipsModule, MatSlideToggleModule, MatRadioGroup, MatRadioButton, CvResultModalComponent, SuccessRegistrationModalComponent, MatCheckbox, RescheduleModalComponent,
        WorkExperienceManagerComponent,
        LoginPopupModalComponent,
        InterviewDialogComponent,
        TranslateDocumentModalComponent,
        ParsingLoadingModalComponent,
        EducationManagerComponent,
        ContactPopupModalComponent,
        EditModalComponent,
        JobApplyModalComponent,
        AppointmentSuccessDialogComponent,
        EmployerPartnerModalComponent,],
    providers: [TranslateService],
} )
export class ModalsModule {
}
